export default __webpack_public_path__ + "locales/lo-LA/ChangePhoneDialog.json?hash=778f42af3e10987fc05d6591edb943d3";